import dayjs from 'dayjs';
import { ComparisonDateUnit } from 'types/common/date';

/**
 * This indicates whether the test is after the source
 *
 * If you want to limit the granularity to a unit other than milliseconds, pass it as the third parameter.
 *
 * Units are case insensitive, and support plural and short forms.
 * @param source date that we want to compare to
 * @param test date that we want to know if it is after the other one
 * @param unit default milliseconds
 * @returns
 */
const dateIsAfter = (source: Date | string, test: Date | string, unit?: ComparisonDateUnit) => dayjs(test).isAfter(source, unit);

export default dateIsAfter;
